import script from "./FormStatusButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FormStatusButton.vue?vue&type=script&setup=true&lang=js"

import "./FormStatusButton.vue?vue&type=style&index=0&id=5d6b38e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6b38e6"]])

export default __exports__